import { useParams } from '@tanstack/react-router';
import { useGetRequest } from '@/api/requests/queries';
import type { Request } from '@/api/requests/types';
import { Sheet, SheetContent } from '@/components/ui/sheet';

import { RequestSheetContent } from './request-sheet-content';

type Props = {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  requestId: string;
  onRequestDelete: () => void;
};

export const RequestSheet = ({ isOpen, setIsOpen, onRequestDelete, requestId }: Props) => {
  const { projectId } = useParams({ strict: false }) as { projectId: string };
  const { data: request, isPending: isRequestPending } = useGetRequest(requestId, projectId);

  return (
    <Sheet open={isOpen} onOpenChange={() => setIsOpen(false)}>
      <SheetContent className="w-full overflow-y-auto sm:w-[600px] sm:max-w-none gap-2 pb-8">
        {isRequestPending || !request ? null : (
          <RequestSheetContent request={request as Request} onRequestDelete={onRequestDelete} />
        )}
      </SheetContent>
    </Sheet>
  );
};
